export default {
	title: 'Model Calculation Mode',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		start: 'Start',
		stop: 'Stop'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		setSuccess: 'Set successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		md: 'Model Category',
		mdcode: 'Model Category Code',
		mversion: 'Version',
		mm: 'Model Subcategory',
		mmcode: 'Model Subcategory Code',
		mdesc: 'Fault Description',
		mDCode: 'Model Category',
		placeholder: {
			md: 'Please enter model category',
			mdcode: 'Please enter model category code',
			mversion: 'Please enter version',
			mm: 'Please enter model subcategory',
			mmcode: 'Please enter model subcategory code',
			mdesc: 'Please enter fault description',
			mDCode: 'Please enter model category'
		}
	},
	table: {
		md: 'Model Category',
		mdcode: 'Model Category Code',
		mm: 'Model Subcategory',
		mmcode: 'Model Subcategory Code',
		mtype: 'Model Type',
		isEnable: 'Enabled',
		mdesc: 'Fault Description',
		mversion: 'Version'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	gridLayout: 'Grid Layout'
}
